const styles = theme => ({
  paperCardFrame: {
    marginBottom: '24px',
    borderRadius: '0px',
  },
  bold: {
    fontWeight: 'bold',
    padding: '0 2px',
  },
  titleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    [theme.breakpoints.up('md')]: {
      borderBottom: '1px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      fontSize: '20px',
      // '& $dangerText': {
      //     color: '#D2374F',
      // },
    },
  },
  title: {
    fontWeight: '600',
    marginBottom: '5px',
  },

  itemCheckboxIndeterminate: {
    color: '#1FCACC !important',
  },
  itemCheckboxChecked: {
    color: `${theme.palette.primary.main} !important`,
    '& .MuiSvgIcon-root': {
      width: '31.5px',
      height: '31.5px',
      fill: '#1FCACC',
    },
  },
  innerCard: {
    '@media (max-width: 480px)': {
      flexDirection: 'column',
    },
  },
  fullWidth_Padding: {
    width: '100%',
  },
  checkBoxContainer: {
    padding: '20px 24px',
    '&.checked': {
      padding: '20px 24px 0 24px',
    },
    '& .MuiSvgIcon-root': {
      width: '31.5px',
      height: '31.5px',
    },
    '& .MuiIconButton-root': {
      padding: '0 9px',
    },
    '& .Mui-checked': {
      color: '#1FCACC !important',
      '& .MuiSvgIcon-root': {
        // fill: '#fff',
      },
    },
  },
  Totalprice: {
    fontWeight: '600',
    lineHeight: '24px',
  },
  checkBoxTitle: {
    fontWeight: '500',
    lineHeight: '24px',
  },
  feesText: {
    marginInlineStart: '1rem',
    fontSize: '14px',
    marginTop: '21px',
  },
  infoMessageTooltip: {
    background: '#EBF7FF',
    color: '#342D3D',
    borderRadius: '10px',
    border: '1px solid #0496FF',
    fontSize: '12px',
    lineHeight: '18px',
    display: 'flex',
    minHeight: '44px',
    padding: '12px',
    marginBottom: '0',
    '& img': {
      marginInlineEnd: '8px',
    },
  },
  totalContainer: {
    color: theme.palette.primary.main,
    fontWeight: '600',
    lineHeight: '24px',
    borderTop: '1px solid #EBEEF3',
    padding: '1rem',
  },
  feesResult: {
    padding: '0 24px',
    paddingBottom: '1rem',
    marginBottom: '1rem',
  },
  feesHeader: {
    fontWeight: '500',
    color: '#130F26',
    paddingTop: '1rem',
  },
  feesTextSmall: {
    fontSize: '12px',
  },
  '@media (max-width:767px)': {
    totalContainer: {
      padding: '.75rem',
    },
    checkBoxContainer: {
      padding: '0 12px',
    },
    feesResult: {
      padding: '0 12px',
    },
    paperCardFrame: {
      border: '0',
      borderRadius: '0',
    },
    titleHead: {
      padding: '16px 24px',
      '& h1': {
        fontSize: '20px',
      },
    },
  },
});

export default styles;
